import { Goal, ID } from '@griply/types';

import { getSubGoals } from './get-sub-goals';

export type GetNotAllowedParentGoalIdsOptions = {
  goals: Goal[];
  currentParentId?: ID;
};

export const getNotAllowedParentGoalIds = (
  id: ID,
  { goals, currentParentId }: GetNotAllowedParentGoalIdsOptions,
): Set<ID> => {
  const subGoals = getSubGoals(id, { goals, recursive: true });
  return new Set<ID>([
    id,
    ...subGoals.map((subGoal) => subGoal.id),
    ...(currentParentId ? [currentParentId] : []),
  ]);
};
